import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';

@Injectable()
export class FuseLoadingInterceptor implements HttpInterceptor
{
    handleRequestsAutomatically: boolean;

    // URLs to exclude from loading bar (polling requests, etc.)
    private readonly EXCLUDED_URLS = [
        'integration/projects/queue-statuses/active',
        'integration/projects/queue-statuses/completed',
        'integration/projects/queue-statuses/',
        'notifications-web',
    ];

    /**
     * Constructor
     */
    constructor(
        private _fuseLoadingService: FuseLoadingService
    )
    {
        // Subscribe to the auto
        this._fuseLoadingService.auto$
            .subscribe((value) => {
                this.handleRequestsAutomatically = value;
            });
    }

    /**
     * Check if URL should be excluded from loading bar
     */
    private shouldExcludeUrl(url: string): boolean
    {
        return this.EXCLUDED_URLS.some(excludedUrl => url.includes(excludedUrl));
    }

    /**
     * Check if request should be excluded from loading bar
     */
    private shouldExcludeRequest(req: HttpRequest<any>): boolean
    {
        // Check URL exclusions
        if (this.shouldExcludeUrl(req.url))
        {
            return true;
        }

        // Check for custom header to exclude from loading bar
        if (req.headers.has('X-Skip-Loading-Bar'))
        {
            return true;
        }

        return false;
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // If the Auto mode is turned off, do nothing
        if ( !this.handleRequestsAutomatically )
        {
            return next.handle(req);
        }

        // Skip loading bar for excluded requests
        if ( this.shouldExcludeRequest(req) )
        {
            return next.handle(req);
        }

        // Set the loading status to true
        this._fuseLoadingService._setLoadingStatus(true, req.url);

        return next.handle(req).pipe(
            finalize(() => {
                // Set the status to false if there are any errors or the request is completed
                this._fuseLoadingService._setLoadingStatus(false, req.url);
            }));
    }
}
